import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {BroadcastsService} from "../../services/broadcasts.service";
import {UtilService} from "../../services/util.service";
import {Broadcast} from "../../model/broadcast/broadcast";
import {UntypedFormControl, UntypedFormGroup, ReactiveFormsModule} from "@angular/forms";
import {Subscription} from "rxjs";
import {BroadcastGamePair} from "../../model/broadcast-game-pair";
import {Game} from "../../model/broadcast/game";
import {MAT_DIALOG_DATA, MatDialogRef, MatDialogModule} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {MatRadioModule} from "@angular/material/radio";
import {MatGridListModule} from "@angular/material/grid-list";
import {MatIconModule} from "@angular/material/icon";
import {NgFor} from "@angular/common";

@Component({
    selector: 'app-custom-table-dialog',
    templateUrl: './custom-table-dialog.component.html',
    styleUrls: ['./custom-table-dialog.component.scss'],
    standalone: true,
    imports: [
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatRadioModule,
        MatGridListModule,
        MatIconModule,
        ReactiveFormsModule,
        NgFor
    ]
})
export class CustomTableDialogComponent implements OnInit, OnDestroy {

  custom: UntypedFormGroup;
  private subs: Subscription[];
  broadcast: Broadcast;
  game: Game;

  constructor(
    public dialogRef: MatDialogRef<CustomTableDialogComponent>,
    public broadcastsService: BroadcastsService,
    public utilService: UtilService,
    @Inject(MAT_DIALOG_DATA) public data: BroadcastGamePair,
  ) {
    this.broadcast = data.broadcast;
    this.game = data.game;
  }

  ngOnInit(): void {
    this.subs = [];
    this.custom = new UntypedFormGroup({
      title: new UntypedFormControl(this.broadcast?.customTable?.title),
      teamGuid: new UntypedFormControl(this.broadcast?.customTable?.teamGuid),
      width: new UntypedFormControl(this.broadcast?.customTable?.width),
    });
    this.initTable();
  }

  private initTable() {
    for (let i = 0; i < 10; i++) {
      if (!this.broadcast.customTable.data[i]) {
        this.broadcast.customTable.data.push({label: '', value: ''})
      }
      this.custom.addControl('label' + i, new UntypedFormControl(this.broadcast?.customTable?.data[i]?.label));
      this.custom.addControl('value' + i, new UntypedFormControl(this.broadcast?.customTable?.data[i]?.value));
    }
  }

  private getData() {
    for (let i = 0; i < 10; i++) {
      this.broadcast.customTable.data[i].label = this.custom.get('label' + i).value;
      this.broadcast.customTable.data[i].value = this.custom.get('value' + i).value;
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  update(): void {
    this.broadcast.customTable.title = this.custom.get('title').value;
    this.broadcast.customTable.teamGuid = this.custom.get('teamGuid').value;
    this.broadcast.customTable.width = this.custom.get('width').value;
    this.getData();
    this.broadcastsService.updateCustomTable(this.broadcast).then(() => {
      this.dialogRef.close('update');
    });
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }
}
